import { axiosService } from "./axiosService";

const userLotteryApi = {
    getAll(params) {
        const url = '/user-lottery/all';
        return axiosService.get(url, { params })
    },
    createMany(body) {
        const url = '/user-lottery/create-many';
        return axiosService.post(url, body)
    },
}

export default userLotteryApi;